// packages
import { Progress } from "@/components/ui/progress2";


// interfaces
interface IUploadProgressProps {
  progress: number;
}

export function UploadProgress({ progress }: IUploadProgressProps) {

  return (
    <div className="space-y-2">
      <Progress value={progress} />
      <p className="text-sm text-center text-gray-500">Carregando ... {progress.toFixed(0)}%</p>
    </div>
  );
}
